import curry from 'lodash/curry';

import IThemeInterface from '../../Theme/common';
import { VALID_GLOBAL_FONT_SIZES } from '../../Typography/common';

import { VALID_PICKED_MEDIA } from './common';

type VALID_THEME_MAP = 'fontSize' | 'edgeSize' | 'container';
type VALID_INDEX_VALUES = VALID_GLOBAL_FONT_SIZES;

export const normalizeMediaStyles = curry((
  theme: IThemeInterface,
  pickedMedia: VALID_PICKED_MEDIA,
  themeIndex: VALID_THEME_MAP,
) => {

  const themeMap = {
    fontSize: theme.global.font.size,
    edgeSize: theme.global.edgeSize,
    container: theme.containerSize,
  };

  const entries = Object.entries(pickedMedia);

  // tslint:disable-next-line:no-any
  return entries.reduce<any>(
    (acc, [key, val]) => ({
      ...acc,
      [key]: themeMap[themeIndex][val as VALID_INDEX_VALUES] || val
    }),
    {}
  );
});
